'use client';

import { SidebarTrigger } from '../appSideBar/sidebar';
import { IconButton } from '../button';

import { BaseTopNavigation } from './BaseTopNavigation';
import { BaseTopNavigationProps } from './type/BaseTopNavigationType';

interface BackButtonTopNavigationProps extends BaseTopNavigationProps {
  isMenuButton?: boolean;
  backButtonColor?: string;
  onBackClick?: () => void;
  onMenuButtonClick?: () => void;
}

export function BackButtonTopNavigation({ isMenuButton, backButtonColor, onBackClick, onMenuButtonClick, ...props }: BackButtonTopNavigationProps) {
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      window.history.back();
    }
  };

  return (
    <BaseTopNavigation
      leftAction={<IconButton variant="main" size="small" iconType="chevron-left" onClick={handleBackClick} color={backButtonColor} aria-label={'go-back'} />}
      rightAction={isMenuButton && <SidebarTrigger />}
      {...props}
    />
  );
}
